export default function PageFooter() {
  return (
    <footer
      className="w-full py-10 sm:py-14"
      style={{ background: '#000', borderTop: '1px solid rgba(234,179,8,0.14)' }}
    >
      <div className="max-w-2xl mx-auto px-5 flex flex-col items-center gap-6">

        {/* Logo */}
        <img
          src="https://static.readdy.ai/image/103ec5ada18b00c7d95516c6aa3b7243/f6ba88513f846dcaf1ba402d9a75d603.png"
          alt="Four Models"
          className="h-16 sm:h-20 object-contain"
          loading="lazy"
        />

        <p
          className="text-xs text-center max-w-xs leading-relaxed"
          style={{ color: '#4B5563', fontFamily: 'Montserrat, sans-serif' }}
        >
          Há mais de 38 anos descobrindo e lançando talentos no mercado da moda, TV e entretenimento.
        </p>

        {/* Divider */}
        <div className="w-20 h-px" style={{ background: 'rgba(234,179,8,0.3)' }} />

        {/* Social icons */}
        <div className="flex items-center gap-3">
          <a
            href="https://www.instagram.com/fourmodelsoficial/"
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="w-10 h-10 flex items-center justify-center rounded-xl transition-all duration-300 cursor-pointer"
            style={{ background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.1)', color: '#6B7280' }}
            onMouseEnter={e => {
              (e.currentTarget as HTMLAnchorElement).style.borderColor = 'rgba(234,179,8,0.7)';
              (e.currentTarget as HTMLAnchorElement).style.color = '#EAB308';
            }}
            onMouseLeave={e => {
              (e.currentTarget as HTMLAnchorElement).style.borderColor = 'rgba(255,255,255,0.1)';
              (e.currentTarget as HTMLAnchorElement).style.color = '#6B7280';
            }}
            aria-label="Instagram Four Models"
          >
            <i className="ri-instagram-line text-lg" />
          </a>
          <a
            href="https://www.facebook.com/fourmodelsoficial"
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="w-10 h-10 flex items-center justify-center rounded-xl transition-all duration-300 cursor-pointer"
            style={{ background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.1)', color: '#6B7280' }}
            onMouseEnter={e => {
              (e.currentTarget as HTMLAnchorElement).style.borderColor = 'rgba(234,179,8,0.7)';
              (e.currentTarget as HTMLAnchorElement).style.color = '#EAB308';
            }}
            onMouseLeave={e => {
              (e.currentTarget as HTMLAnchorElement).style.borderColor = 'rgba(255,255,255,0.1)';
              (e.currentTarget as HTMLAnchorElement).style.color = '#6B7280';
            }}
            aria-label="Facebook Four Models"
          >
            <i className="ri-facebook-circle-line text-lg" />
          </a>
          <a
            href="https://wa.me/5551998977297"
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="w-10 h-10 flex items-center justify-center rounded-xl transition-all duration-300 cursor-pointer"
            style={{ background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.1)', color: '#6B7280' }}
            onMouseEnter={e => {
              (e.currentTarget as HTMLAnchorElement).style.borderColor = 'rgba(234,179,8,0.7)';
              (e.currentTarget as HTMLAnchorElement).style.color = '#EAB308';
            }}
            onMouseLeave={e => {
              (e.currentTarget as HTMLAnchorElement).style.borderColor = 'rgba(255,255,255,0.1)';
              (e.currentTarget as HTMLAnchorElement).style.color = '#6B7280';
            }}
            aria-label="WhatsApp Four Models"
          >
            <i className="ri-whatsapp-line text-lg" />
          </a>
        </div>

        {/* Bottom line */}
        <div className="border-t w-full pt-5" style={{ borderColor: 'rgba(255,255,255,0.07)' }}>
          <p className="text-xs text-center" style={{ color: '#374151', fontFamily: 'Montserrat, sans-serif' }}>
            &copy; 2026 Four Models Seletivas. Todos os direitos reservados.
          </p>
        </div>

      </div>
    </footer>
  );
}
